import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppShell from './components/AppShell';
import ErrorBoundary from './components/ErrorBoundary';
import CollectionPage from './pages/CollectionPage';
import WalletPage from './pages/WalletPage';
import { collectionMap } from './const/CollectionsInfo';

const App = () => (
    <BrowserRouter>
        <ErrorBoundary>
            <Routes>
                <Route element={<AppShell />}>
                    <Route index element={<Navigate to='/land' replace />} />
                    {Object.values(collectionMap).map((collection) => (
                        <Route
                            key={collection.collectionPath}
                            path={`/${collection.collectionPath}`}
                            element={<CollectionPage key={collection.collectionPath} collection={collection} />}
                        />
                    ))}
                    <Route path='/wallet' element={<WalletPage />} />
                    <Route path='*' element={<Navigate to='/land' replace />} />
                </Route>
            </Routes>
        </ErrorBoundary>
    </BrowserRouter>
);

export default App;
